import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    checkbox: {
        padding: 0,
        marginRight: theme.spacing(1.5),
        pointerEvents: 'none',
    },
}));
//# sourceMappingURL=OptionWithCheckbox.styles.js.map